<template>
    <div v-if="currentInstanceActiveApps.length">
        <div v-for="app in currentInstanceActiveApps" :key="app.sessionId">
            <ApplicationMenuItem :appData="app" :collapsed="collapsed" />
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { sortBy } from 'lodash'

const ApplicationMenuItem = () => import('./TheApplicationSidebarMenuItem.vue')

export default {
    components: {
        ApplicationMenuItem
    },
    props: {
        collapsed: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState('snapshotStore', ['applications']),
        ...mapGetters('appStore', ['activeDeployments']),
        currentInstanceActiveApps() {
            return sortBy(
                this.activeDeployments.filter(a => {
                    return this.applications.some(available => available.aid.toString() === a.aid.toString())
                }),
                'creation_timestamp'
            )
        }
    }
}
</script>
